
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.297 12a2.297 2.297 0 11-4.594 0 2.297 2.297 0 014.594 0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M17.372 7.936c-.11-.299-.287-.57-.516-.792a2.133 2.133 0 00-.792-.516c-.243-.094-.608-.206-1.28-.237-.726-.033-.944-.04-2.784-.04-1.84 0-2.058.007-2.784.04-.672.03-1.037.143-1.28.237-.3.11-.57.287-.792.516a2.136 2.136 0 00-.516.792c-.094.243-.206.608-.237 1.28-.033.726-.04.944-.04 2.784 0 1.84.007 2.058.04 2.785.03.671.143 1.036.237 1.279.11.3.287.57.516.792.222.23.493.405.792.516.243.094.608.206 1.28.237.726.033.944.04 2.784.04 1.84 0 2.058-.007 2.784-.04.672-.03 1.037-.143 1.28-.237a2.282 2.282 0 001.308-1.308c.094-.243.206-.607.237-1.28.033-.726.04-.944.04-2.784 0-1.84-.007-2.058-.04-2.784-.03-.672-.143-1.037-.237-1.28zM12 15.538a3.538 3.538 0 110-7.076 3.538 3.538 0 010 7.076zm3.678-6.39a.827.827 0 110-1.653.827.827 0 010 1.654z","fill":"#fff"}}),_c('path',{attrs:{"d":"M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12 12-5.374 12-12S18.626 0 12 0zm6.85 14.84c-.034.734-.15 1.235-.321 1.674a3.524 3.524 0 01-2.015 2.015c-.439.17-.94.287-1.673.32-.735.034-.97.042-2.84.042-1.872 0-2.107-.008-2.842-.042-.733-.033-1.234-.15-1.672-.32a3.375 3.375 0 01-1.221-.795 3.377 3.377 0 01-.795-1.22c-.17-.439-.287-.94-.32-1.673-.034-.735-.042-.97-.042-2.841 0-1.871.008-2.106.042-2.84.033-.734.15-1.235.32-1.674.173-.46.444-.876.795-1.22.344-.35.76-.622 1.22-.795.439-.17.94-.287 1.673-.32.735-.034.97-.042 2.841-.042 1.871 0 2.106.008 2.84.042.734.033 1.235.15 1.674.32.46.173.876.444 1.22.795.35.344.622.76.795 1.22.17.439.287.94.32 1.673.034.735.042.97.042 2.841 0 1.871-.008 2.106-.042 2.84z","fill":"#fff"}})])
          )
        }
      }
    